import { useQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { employeeKeys } from '@petseo/shared';

export const useEmployeeName = (serviceVendorId: ServiceVendorId, employeeId: EmployeeId) => {
  return useQuery({
    queryKey: employeeKeys.forVendor(serviceVendorId),
    queryFn: async () => {
      const response = await serviceVendorsClient.getEmployeesEndpoint(serviceVendorId);
      return response.data;
    },
    select: (data) => {
      const emp = (data.employees ?? []).find((e) => String(e.id) === String(employeeId));
      return emp ? `${emp.firstName} ${emp.lastName}` : undefined;
    },
    enabled: !!serviceVendorId && !!employeeId,
  });
};
